import React, { useEffect, useState } from 'react';
import { clone } from 'lodash';

import { Input } from '@components/atoms';
import { icons } from '@assets/icons';
import { CompanyListProps } from '@models/transfer/companyList';
import { DataProps } from '@models/transfer/common';
import { StyledAllCompany, StyledBody, StyledHeader } from './style';

const CompanyList = ({ type, dataList, cilckedList, setCilckedList }: CompanyListProps) => {
  const [searchId, setSearchId] = useState('');
  const [searchCompany, setSearchCompany] = useState('');
  const [list, setList] = useState<DataProps[]>([]);

  const rowClassName = (id: number) => {
    const isRowActive = cilckedList.filter((clickedRow) => clickedRow.id === id).length !== 0;

    return isRowActive;
  };

  const clickedCompany = (row: DataProps) => {
    const cloneList = clone(cilckedList);

    const isRowActive = !rowClassName(row.id);

    if (isRowActive) {
      cloneList.push(row);
      setCilckedList(cloneList);
    } else {
      const cloneFilter = cloneList.filter((value) => value.id !== row.id);
      setCilckedList(cloneFilter);
    }
  };

  const onClickClearIcon = (e: any) => {
    if (e.target.className === 'searchId') {
      setSearchId('');
    } else if (e.target.className === 'searchCompany') {
      setSearchCompany('');
    }
  };

  useEffect(() => {
    setList(dataList);
  }, [dataList]);

  useEffect(() => {
    const filterList = dataList.filter((row) => {
      return String(row.id).includes(searchId) && row.name.includes(searchCompany);
    });
    setList(filterList);
  }, [searchId, searchCompany]);

  return (
    <>
      <StyledAllCompany>
        <div>
          <h3>{type} Company</h3>
          <span>
            {cilckedList.length}/{list.length}
          </span>
        </div>

        <StyledHeader>
          <div className="sendingHeader">
            <div className="firstColumn">ID</div>
            <div className="secondColumn">Company</div>
          </div>

          <div className="sendingSearch">
            <div>
              <Input
                className="firstColumn"
                type={'text'}
                placeholder={'Search ID'}
                value={searchId}
                onChange={(e) => setSearchId(e.target.value)}
              />
              {searchId && (
                <img
                  className="searchId"
                  src={icons.deleteIcon}
                  alt="clear"
                  onClick={(e) => onClickClearIcon(e)}
                />
              )}
            </div>

            <div>
              <Input
                className="secondColumn"
                type={'text'}
                placeholder={'Search Company'}
                value={searchCompany}
                onChange={(e) => setSearchCompany(e.target.value)}
              />
              {searchCompany && (
                <img
                  className="searchCompany"
                  src={icons.deleteIcon}
                  alt="clear"
                  onClick={(e) => onClickClearIcon(e)}
                />
              )}
            </div>
          </div>
        </StyledHeader>

        <StyledBody>
          {list.length === 0 ? (
            <div className="noList">No matching search results found.</div>
          ) : (
            list.map((row, i) => {
              return (
                <div
                  key={i}
                  className={`bodyRow ${rowClassName(row.id) ? 'selected' : ''}`}
                  onClick={(e) => clickedCompany(row)}
                >
                  <div className="td-id">{row.id}</div>
                  <div className="td-company">{row.name}</div>
                  {row.licenseActivate && <div className="td-activated">Activated</div>}
                </div>
              );
            })
          )}
        </StyledBody>
      </StyledAllCompany>
    </>
  );
};

export default CompanyList;
